import React from 'react';
const SortByFilter = ({ searchData, dropdownList, value }) => {
  return (
    <>
      <select
        name="sortBy"
        id="sortBy"
        onChange={(e) => {
          searchData('sortBy', e.target.value);
        }}
        value={value}
        className="inline-block py-1 px-2  h-[42px] text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-slate-700 dark:border-slate-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        {dropdownList &&
          dropdownList.map((list, index) => {
            return (
              <option key={index} value={list.value}>
                {list.name}
              </option>
            );
          })}
      </select>
    </>
  );
};

export default SortByFilter;
